module.exports = __webpack_public_path__ + "static/media/sensative-icon.05596c2f.svg";